import { render } from "./HorsePreviewPedigree.vue?vue&type=template&id=34d3107c"
import script from "./HorsePreviewPedigree.vue?vue&type=script&lang=js"
export * from "./HorsePreviewPedigree.vue?vue&type=script&lang=js"

import "./HorsePreviewPedigree.vue?vue&type=style&index=0&id=34d3107c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__